import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["header", "size", "docUrl", "closeOnEscape", "closeModal", "isOpen", "children", "showResetButton", "submitButtonLabel", "cancelButtonLabel", "resetButtonLabel", "submitButtonClass", "submitButtonDisabled"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'orion/lib/form';
import Button from 'orion/lib/button';
import Modal from 'orion/lib/modal';

var FormModal = function FormModal(_ref) {
  var header = _ref.header,
      size = _ref.size,
      docUrl = _ref.docUrl,
      closeOnEscape = _ref.closeOnEscape,
      closeModal = _ref.closeModal,
      isOpen = _ref.isOpen,
      children = _ref.children,
      showResetButton = _ref.showResetButton,
      submitButtonLabel = _ref.submitButtonLabel,
      cancelButtonLabel = _ref.cancelButtonLabel,
      resetButtonLabel = _ref.resetButtonLabel,
      submitButtonClass = _ref.submitButtonClass,
      submitButtonDisabled = _ref.submitButtonDisabled,
      formProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Form // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, formProps, {
    renderChildren: function renderChildren(formikBag) {
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        toggle: closeModal,
        header: header,
        size: size,
        docUrl: docUrl,
        closeOnEscape: closeOnEscape,
        body: function body() {
          var _context;

          return _mapInstanceProperty(_context = React.Children).call(_context, children, function (child) {
            return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, formikBag), formProps));
          });
        },
        footer: function footer() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            label: cancelButtonLabel,
            onClick: closeModal
          }), showResetButton && /*#__PURE__*/React.createElement(Button, {
            type: "primary",
            label: resetButtonLabel,
            onClick: function onClick() {
              return formikBag.resetForm();
            }
          }), /*#__PURE__*/React.createElement(Button, {
            className: submitButtonClass,
            disabled: submitButtonDisabled || !formikBag.dirty,
            type: "primary",
            label: submitButtonLabel,
            onClick: function onClick() {
              return formikBag.submitForm();
            }
          }));
        }
      });
    }
  }));
};

FormModal.defaultProps = {
  closeModal: function closeModal() {},
  header: '',
  submitButtonLabel: 'Submit',
  cancelButtonLabel: 'Cancel',
  resetButtonLabel: 'Reset',
  showResetButton: false
};
FormModal.propTypes = {
  header: PropTypes.string,
  size: PropTypes.string,
  docUrl: PropTypes.string,
  closeOnEscape: PropTypes.bool,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
  showResetButton: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  submitButtonLabel: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  resetButtonLabel: PropTypes.string,
  submitButtonDisabled: PropTypes.bool,
  submitButtonClass: PropTypes.string
};
FormModal.displayName = 'OrionFormModal';
export default FormModal;